import { CategoryFilter, CategoryFilterType } from '../category-filter.model';
import { StringValueId } from '../filter-supported-type.model';

//import { FilterSupportedType, StringValueId } from '../filter-supported-type.model';

export class GenericCheckboxFilter {
  isChecked: boolean;
  value: StringValueId;
}

export class GenericCheckboxCategoryFilter extends CategoryFilter {
  name: string;
  filters: GenericCheckboxFilter[];

  get type() {
    return CategoryFilterType.Checkbox;
  }

  get showFilter(): boolean {
    return this.filters.length > 0;
  }

  get isAllChecked(): boolean {
    return (this.filters) && this.filters.length > 0
      && this.filters.every(filter => !filter.isChecked);
  }

  set isAllChecked(value: boolean) {
    if (this.filters) {
      this.filters.forEach(f => f.isChecked = false);
    }
  }

  reset() {
    if (this.filters) {
      this.filters.forEach(f => f.isChecked = false);
    }
  }
}
